import Splide from '@splidejs/splide';

const appCarousel = () => {
    const $ = jQuery;
    const wrappers = $('.app-carousel .app-carousel-wrapper');

    if (wrappers.length === 0) {
        return true;
    }

    wrappers.each((i, wrapper) => {
        const appCarousel = new Splide(wrapper, {
            type: 'loop',  // Changed from 'slider' to 'loop'
            loop: true,
            perPage: 2.75,
            gap: '2rem',
            focus: 'center',
            arrows: true,
            pagination: false,
            rewind: false,  // Ensure proper loop behavior
            rewindByDrag: false,
            clones: 2,  // Explicitly set number of clones
            breakpoints: {
                769: {
                    perPage: 1.25,
                    focus: 'left',
                },
                1660: {
                    perPage: 2.25,
                }
            }
        });

        wrapper.querySelectorAll('.splide__pagination__page').forEach((button, index) => {
            button.addEventListener('click', () => {
                appCarousel.go(index); // Move to the clicked slide index
            });
        });

        appCarousel.on('move', (newIndex) => {
            document.querySelectorAll('.splide__pagination__page').forEach((button, index) => {
                if (index === newIndex) {
                    button.setAttribute('aria-selected', 'true');
                    button.setAttribute('tabindex', '0');
                } else {
                    button.setAttribute('aria-selected', 'false');
                    button.setAttribute('tabindex', '-1');
                }
            });
        });

        appCarousel.mount(); // Simply mount without specifying components
    });
};

export default appCarousel;